<p-toast position="top-right" [key]="Constants.Notifications.ERROR_KEY"></p-toast>
<p-toast position="top-right" [key]="Constants.Notifications.SUCCESS_KEY"></p-toast>
<router-outlet />
<app-spinner></app-spinner>
